import { OrganizationRoleCompany } from "src/pages/Settings/Users/OrganizationRolesSection/types";

export const byCompanyId = (company: OrganizationRoleCompany) => company.id;

export const dedupeCompanies = (companies: OrganizationRoleCompany[]) => {
    const seenCompanyIds = new Set<number>();

    return companies.filter((company) => {
        if (seenCompanyIds.has(company.id)) {
            return false;
        }

        seenCompanyIds.add(company.id);
        return true;
    });
};
